
import Vue, {VueConstructor} from 'vue'
import QueryMixin from '~/mixins/query.mixin'
import ResponsiveMixin from '~/mixins/responsive.mixin'
import {ChefInterface} from "~/store/chef";
import ChefCard from "~/components/index/chef-highlight/chef-card.vue";

export default (Vue as VueConstructor<Vue & InstanceType<typeof ResponsiveMixin> & InstanceType<typeof QueryMixin>>).extend({
  name: 'ProfileReviewsIndex',
  components: {ChefCard},
  mixins: [ResponsiveMixin, QueryMixin],
  head() {
    return {
      bodyAttrs: {
        class: 'bg-white text-offBlack'
      },
      title: this.$data.seoTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$data.seoDescriptionMeta,
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: this.$data.productJSON,
        }
      ],
    }
  },
  data(): {
    mobileMenuOpen: boolean,
    showChefScorePopup: boolean,
    seoTitle: string,
    seoDescriptionMeta: string,
    productJSON: object,
    chef: ChefInterface | null,
  } {
    return {
      mobileMenuOpen: false,
      showChefScorePopup: false,
      seoTitle: '',
      seoDescriptionMeta: '',
      productJSON: {},
      chef: null,
    }
  },
  computed: {
    chefIdOrSlug(): string {
      return this.$route.params.id
    },
  },
  async fetch() {
    // @ts-ignore
    this.chef = await this.$axios.$get<{ data: ChefInterface }>(`/v1/chef/${this.chefIdOrSlug}`).then(data => data.data).catch(() => {
      this.$nuxt.context.redirect('/');
      return;
    });

    if (!this.chef) {
      return;
    }

    this.seoTitle = `${this.chef.display_name} profiel`;
    this.seoDescriptionMeta = `Bekijk hier het profiel van ${this.chef.display_name}`;

    this.productJSON = {
      "@context": "https://schema.org/",
      "@type": "Product",
      "name": this.chef.display_name,
      "description": this.chef.description,
      "offers": {
        "@type": "AggregateOffer",
        "offerCount": String(this.chef.listings.length),
        "lowPrice": String(this.chef.price_from_in_cents / 100),
        "highPrice": String(this.chef.price_to_in_cents / 100),
        "priceCurrency": "EUR"
      }
    };

    if (this.chef.review_amount > 0) {
      // @ts-ignore
      this.productJSON['aggregateRating'] = {
        "@type": "AggregateRating",
        "ratingValue": String(this.chef.review_score),
        "bestRating": "10",
        "ratingCount": String(this.chef.review_amount)
      };
    }

    if (this.chef.profile_picture) {
      // @ts-ignore
      this.productJSON['image'] = [
        this.chef.profile_picture.url
      ];
    }
  }
})
